var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGetOnAppleStore(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 292,
    height: 89,
    viewBox: "0 0 77.258 23.548",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath31"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(-234.88 -95.235)",
    d: "M 0,176.279 H 267.564 V 0 H 0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath33"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(-33.648 -156.87)",
    d: "M 0,176.279 H 267.564 V 0 H 0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath35"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(-100.92 -141.72)",
    d: "M 0,176.279 H 267.564 V 0 H 0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath37"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(-107.13 -144.89)",
    d: "M 0,176.279 H 267.564 V 0 H 0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath39"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(-118.46 -141)",
    d: "M 0,176.279 H 267.564 V 0 H 0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath41"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,176.279 H 267.564 V 0 H 0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath43"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,176.279 H 267.564 V 0 H 0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath45"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(-136.45 -141)",
    d: "M 0,176.279 H 267.564 V 0 H 0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath47"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(-142.96 -140.42)",
    d: "M 0,176.279 H 267.564 V 0 H 0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath49"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,176.279 H 267.564 V 0 H 0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath51"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(-160.25 -141.89)",
    d: "M 0,176.279 H 267.564 V 0 H 0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath53"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(-171.6 -138.5)",
    d: "M 0,176.279 H 267.564 V 0 H 0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath55"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(-177.7 -142.62)",
    d: "M 0,176.279 H 267.564 V 0 H 0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath57"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(-193.43 -146.84)",
    d: "M 0,176.279 H 267.564 V 0 H 0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath59"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(-197.39 -148.38)",
    d: "M 0,176.279 H 267.564 V 0 H 0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath61"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(-211.7 -141.89)",
    d: "M 0,176.279 H 267.564 V 0 H 0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath63"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(-74.025 -127.08)",
    d: "M 0,176.279 H 267.564 V 0 H 0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath65"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(-68.854 -142.39)",
    d: "M 0,176.279 H 267.564 V 0 H 0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath67"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(-105.71 -117.14)",
    d: "M 0,176.279 H 267.564 V 0 H 0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath69"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(-126.22 -115.99)",
    d: "M 0,176.279 H 267.564 V 0 H 0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath71"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(-144 -115.99)",
    d: "M 0,176.279 H 267.564 V 0 H 0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath73"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(-167.38 -114.21)",
    d: "M 0,176.279 H 267.564 V 0 H 0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath75"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(-178.73 -121.08)",
    d: "M 0,176.279 H 267.564 V 0 H 0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath77"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(-192.25 -115.94)",
    d: "M 0,176.279 H 267.564 V 0 H 0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath79"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(-206.97 -120.64)",
    d: "M 0,176.279 H 267.564 V 0 H 0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath81"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(-219.06 -117.55)",
    d: "M 0,176.279 H 267.564 V 0 H 0 Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.26458 0 0 .26458 -8.7372 -5.8032)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.3333 0 0 -1.3333 313.18 108.06)",
    d: "m0 0h-201.24c-4.077 0-7.382 3.305-7.382 7.382v47.674c0 4.076 3.305 7.381 7.382 7.381h201.24c4.077 0 7.382-3.305 7.382-7.381v-47.674c0-4.077-3.305-7.382-7.382-7.382",
    clipPath: "url(#clipPath31)",
    fill: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.3333 0 0 -1.3333 44.865 25.885)",
    d: "m0 0c-3.625 0-6.574-2.949-6.574-6.575v-47.673c0-3.625 2.949-6.574 6.574-6.574h201.24c3.625 0 6.575 2.949 6.575 6.574v47.673c0 3.626-2.95 6.575-6.575 6.575zm201.24-62.437h-201.24c-4.516 0-8.189 3.673-8.189 8.189v47.673c0 4.516 3.673 8.19 8.189 8.19h201.24c4.516 0 8.19-3.674 8.19-8.19v-47.673c0-4.516-3.674-8.189-8.19-8.189",
    clipPath: "url(#clipPath33)",
    fill: "#a7a5a6"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.3333 0 0 -1.3333 134.56 46.082)",
    d: "m0 0-0.828 2.591c-0.202 0.64-0.374 1.358-0.53 1.967h-0.032c-0.155-0.609-0.312-1.342-0.499-1.967l-0.812-2.591zm-3.013-1.452-0.905-2.981h-1.983l3.372 10.521h2.451l3.418-10.521h-2.06l-0.952 2.981z",
    clipPath: "url(#clipPath35)"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.3333 0 0 -1.3333 142.84 41.857)",
    d: "m0 0 1.233-3.856c0.219-0.671 0.374-1.28 0.515-1.904h0.047c0.141 0.624 0.312 1.218 0.515 1.904l1.217 3.856h2.014l-2.903-7.602h-1.889l-2.825 7.602z",
    clipPath: "url(#clipPath37)"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.3333 0 0 -1.3333 157.95 47.039)",
    d: "m0 0c-1.358 0.016-2.654-0.266-2.654-1.421 0-0.749 0.484-1.092 1.093-1.092 0.78 0 1.327 0.499 1.514 1.046 0.047 0.14 0.047 0.28 0.047 0.421zm1.873-1.889c0-0.687 0.031-1.358 0.125-1.826h-1.733l-0.14 0.842h-0.047c-0.453-0.592-1.249-1.014-2.248-1.014-1.53 0-2.388 1.108-2.388 2.263 0 1.905 1.702 2.888 4.511 2.873v0.125c0 0.499-0.203 1.326-1.545 1.326-0.749 0-1.53-0.234-2.045-0.562l-0.375 1.249c0.562 0.343 1.546 0.671 2.747 0.671 2.436 0 3.138-1.545 3.138-3.215z",
    clipPath: "url(#clipPath39)"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.3333 0 0 -1.3333 0 235.04)",
    d: "m123.05 144.89h1.92v-7.602h-1.92zm0.952 1.093c-0.64 0-1.062 0.468-1.062 1.03 0 0.593 0.437 1.046 1.078 1.046 0.655 0 1.061-0.453 1.077-1.046 0-0.562-0.422-1.03-1.077-1.03z",
    clipPath: "url(#clipPath41)"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.3333 0 0 -1.3333 0 235.04)",
    d: "m127.73 148.38h1.92v-11.099h-1.92z",
    clipPath: "url(#clipPath43)"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.3333 0 0 -1.3333 181.94 47.039)",
    d: "m0 0c-1.357 0.016-2.654-0.266-2.654-1.421 0-0.749 0.484-1.092 1.093-1.092 0.781 0 1.328 0.499 1.514 1.046 0.047 0.14 0.047 0.28 0.047 0.421zm1.874-1.889c0-0.687 0.031-1.358 0.124-1.826h-1.732l-0.141 0.842h-0.047c-0.452-0.592-1.248-1.014-2.248-1.014-1.53 0-2.388 1.108-2.388 2.263 0 1.905 1.702 2.888 4.511 2.873v0.125c0 0.499-0.202 1.326-1.545 1.326-0.749 0-1.53-0.234-2.045-0.562l-0.375 1.249c0.562 0.343 1.546 0.671 2.748 0.671 2.435 0 3.138-1.545 3.138-3.215z",
    clipPath: "url(#clipPath45)"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.3333 0 0 -1.3333 190.62 47.81)",
    d: "m0 0c0-0.156 0.016-0.312 0.047-0.453 0.203-0.78 0.874-1.342 1.701-1.342 1.202 0 1.936 0.952 1.936 2.497 0 1.343-0.64 2.435-1.92 2.435-0.781 0-1.498-0.561-1.702-1.405-0.031-0.14-0.062-0.312-0.062-0.499zm-1.92 7.961h1.92v-4.543h0.031c0.469 0.734 1.296 1.218 2.436 1.218 1.857 0 3.183-1.545 3.168-3.856 0-2.731-1.733-4.09-3.449-4.09-0.984 0-1.858 0.375-2.405 1.312h-0.031l-0.094-1.14h-1.638c0.031 0.515 0.062 1.358 0.062 2.123z",
    clipPath: "url(#clipPath47)"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.3333 0 0 -1.3333 0 235.04)",
    d: "m150.86 148.38h1.92v-11.099h-1.92z",
    clipPath: "url(#clipPath49)"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.3333 0 0 -1.3333 213.67 45.853)",
    d: "m0 0c0.016 0.702-0.296 1.857-1.576 1.857-1.187 0-1.686-1.077-1.764-1.857zm-3.34-1.343c0.047-1.373 1.123-1.967 2.341-1.967 0.89 0 1.515 0.141 2.107 0.344l0.282-1.311c-0.656-0.281-1.562-0.484-2.654-0.484-2.466 0-3.919 1.514-3.919 3.84 0 2.107 1.281 4.089 3.716 4.089 2.466 0 3.278-2.029 3.278-3.699 0-0.359-0.032-0.64-0.062-0.812z",
    clipPath: "url(#clipPath51)"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.3333 0 0 -1.3333 228.8 50.37)",
    d: "m0 0c1.092 0 1.857 1.061 1.857 2.606 0 1.187-0.531 2.561-1.841 2.561-1.359 0-1.906-1.327-1.906-2.592 0-1.467 0.735-2.575 1.874-2.575zm-0.062-1.39c-2.139 0-3.81 1.468-3.81 3.918 0 2.498 1.64 4.028 3.934 4.028 2.263 0 3.778-1.592 3.778-3.903 0-2.794-1.967-4.043-3.887-4.043z",
    clipPath: "url(#clipPath53)"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.3333 0 0 -1.3333 236.93 44.875)",
    d: "m0 0c0 0.875-0.031 1.608-0.062 2.264h1.669l0.094-1.14h0.047c0.344 0.593 1.171 1.311 2.436 1.311 1.326 0 2.7-0.858 2.7-3.262v-4.511h-1.92v4.292c0 1.093-0.406 1.921-1.452 1.921-0.765 0-1.295-0.547-1.498-1.125-0.063-0.156-0.094-0.39-0.094-0.608v-4.48h-1.92z",
    clipPath: "url(#clipPath55)"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.3333 0 0 -1.3333 257.91 39.256)",
    d: "m0 0v-1.951h1.826v-1.436h-1.826v-3.341c0-0.937 0.25-1.405 0.983-1.405 0.343 0 0.531 0.016 0.749 0.078l0.032-1.451c-0.282-0.11-0.796-0.203-1.39-0.203-0.718 0-1.295 0.234-1.654 0.624-0.422 0.437-0.609 1.14-0.609 2.139v3.559h-1.077v1.436h1.077v1.42z",
    clipPath: "url(#clipPath57)"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.3333 0 0 -1.3333 263.19 37.195)",
    d: "m0 0h1.92v-4.527h0.031c0.235 0.359 0.562 0.656 0.952 0.859 0.391 0.218 0.843 0.343 1.327 0.343 1.295 0 2.654-0.859 2.654-3.294v-4.48h-1.92v4.277c0 1.093-0.406 1.936-1.468 1.936-0.749 0-1.279-0.499-1.498-1.077-0.062-0.172-0.078-0.375-0.078-0.578v-4.558h-1.92z",
    clipPath: "url(#clipPath59)"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.3333 0 0 -1.3333 282.27 45.853)",
    d: "m0 0c0.016 0.702-0.296 1.857-1.576 1.857-1.187 0-1.686-1.077-1.764-1.857zm-3.34-1.343c0.047-1.373 1.123-1.967 2.341-1.967 0.89 0 1.515 0.141 2.107 0.344l0.282-1.311c-0.656-0.281-1.562-0.484-2.654-0.484-2.466 0-3.919 1.514-3.919 3.84 0 2.107 1.281 4.089 3.716 4.089 2.466 0 3.278-2.029 3.278-3.699 0-0.359-0.032-0.64-0.062-0.812z",
    clipPath: "url(#clipPath61)"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.3333 0 0 -1.3333 98.7 65.599)",
    d: "m0 0c-0.049 5.206 4.264 7.74 4.46 7.857-2.439 3.563-6.226 4.048-7.555 4.086-3.177 0.334-6.261-1.904-7.877-1.904-1.651 0-4.149 1.87-6.833 1.816-3.458-0.055-6.694-2.057-8.466-5.164-3.66-6.338-0.93-15.652 2.576-20.778 1.756-2.508 3.806-5.31 6.489-5.21 2.624 0.109 3.604 1.672 6.774 1.672 3.141 0 4.062-1.672 6.799-1.609 2.818 0.046 4.59 2.52 6.282 5.053 2.031 2.875 2.844 5.707 2.876 5.853-0.066 0.022-5.471 2.084-5.525 8.328",
    clipPath: "url(#clipPath63)"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.3333 0 0 -1.3333 91.805 45.182)",
    d: "m0 0c1.412 1.766 2.381 4.17 2.108 6.607-2.043-0.091-4.597-1.413-6.068-3.141-1.303-1.522-2.469-4.018-2.167-6.363 2.298-0.17 4.653 1.159 6.127 2.897",
    clipPath: "url(#clipPath65)"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.3333 0 0 -1.3333 140.94 78.856)",
    d: "m0 0-1.811 5.598c-0.194 0.57-0.553 1.918-1.083 4.037h-0.063c-0.213-0.913-0.553-2.258-1.02-4.037l-1.781-5.598zm6.264-8.941h-3.657l-2.004 6.299h-6.963l-1.911-6.299h-3.561l6.904 21.438h4.259z",
    clipPath: "url(#clipPath67)"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.3333 0 0 -1.3333 168.29 80.384)",
    d: "m0 0c0 1.505-0.34 2.745-1.018 3.722-0.743 1.016-1.74 1.527-2.988 1.527-0.849 0-1.621-0.285-2.306-0.843-0.689-0.566-1.141-1.301-1.353-2.214-0.106-0.425-0.157-0.772-0.157-1.046v-2.579c0-1.124 0.343-2.072 1.03-2.845 0.691-0.777 1.587-1.16 2.689-1.16 1.294 0 2.302 0.495 3.02 1.493 0.724 0.998 1.083 2.311 1.083 3.945m3.499 0.126c0-2.629-0.71-4.708-2.132-6.234-1.272-1.358-2.853-2.035-4.737-2.035-2.037 0-3.501 0.734-4.391 2.195h-0.061v-8.142h-3.438v16.666c0 1.653-0.041 3.347-0.126 5.088h3.02l0.192-2.45h0.065c1.144 1.846 2.884 2.768 5.215 2.768 1.821 0 3.346-0.721 4.564-2.164 1.219-1.444 1.829-3.34 1.829-5.692",
    clipPath: "url(#clipPath69)"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.3333 0 0 -1.3333 192 80.384)",
    d: "m0 0c0 1.505-0.34 2.745-1.021 3.722-0.742 1.016-1.737 1.527-2.988 1.527-0.849 0-1.619-0.285-2.305-0.843-0.69-0.566-1.139-1.301-1.35-2.214-0.109-0.425-0.16-0.772-0.16-1.046v-2.579c0-1.124 0.342-2.072 1.031-2.845 0.689-0.777 1.583-1.16 2.69-1.16 1.291 0 2.301 0.495 3.02 1.493s1.083 2.311 1.083 3.945m3.495 0.126c0-2.629-0.708-4.708-2.131-6.234-1.272-1.358-2.849-2.035-4.738-2.035-2.035 0-3.496 0.734-4.388 2.195h-0.062v-8.142h-3.435v16.666c0 1.653-0.045 3.347-0.127 5.088h3.02l0.192-2.45h0.066c1.14 1.846 2.879 2.768 5.213 2.768 1.822 0 3.344-0.721 4.565-2.164 1.219-1.444 1.825-3.34 1.825-5.692",
    clipPath: "url(#clipPath71)"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.3333 0 0 -1.3333 223.17 82.76)",
    d: "m0 0c0-1.823-0.632-3.306-1.906-4.453-1.396-1.252-3.341-1.876-5.837-1.876-2.306 0-4.157 0.445-5.559 1.335l0.797 2.862c1.51-0.912 3.163-1.366 4.967-1.366 1.294 0 2.302 0.291 3.024 0.873 0.719 0.586 1.078 1.367 1.078 2.343 0 0.869-0.295 1.605-0.888 2.198-0.593 0.596-1.583 1.147-2.962 1.658-3.753 1.403-5.626 3.451-5.626 6.149 0 1.762 0.654 3.207 1.971 4.331 1.313 1.126 3.063 1.691 5.248 1.691 1.952 0 3.574-0.342 4.865-1.018l-0.858-2.8c-1.209 0.656-2.575 0.986-4.104 0.986-1.209 0-2.151-0.296-2.828-0.891-0.57-0.529-0.858-1.178-0.858-1.94 0-0.847 0.326-1.549 0.984-2.098 0.57-0.509 1.61-1.06 3.117-1.655 1.845-0.744 3.199-1.612 4.071-2.607 0.868-0.998 1.304-2.239 1.304-3.722",
    clipPath: "url(#clipPath73)"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.3333 0 0 -1.3333 238.31 73.599)",
    d: "m0 0h-3.785v-7.506c0-1.909 0.668-2.863 2.006-2.863 0.61 0 1.121 0.054 1.523 0.158l0.095-2.607c-0.675-0.255-1.568-0.381-2.67-0.381-1.357 0-2.418 0.412-3.181 1.238-0.762 0.827-1.145 2.218-1.145 4.168v7.793h-2.258v2.578h2.258v2.828l3.372 1.02v-3.848h3.785z",
    clipPath: "url(#clipPath75)"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.3333 0 0 -1.3333 256.33 80.448)",
    d: "m0 0c0 1.425-0.306 2.646-0.923 3.667-0.718 1.234-1.748 1.851-3.083 1.851-1.381 0-2.43-0.617-3.148-1.851-0.617-1.021-0.92-2.264-0.92-3.733 0-1.425 0.303-2.646 0.92-3.666 0.74-1.233 1.779-1.85 3.119-1.85 1.311 0 2.341 0.626 3.081 1.882 0.637 1.041 0.954 2.274 0.954 3.7m3.563 0.111c0-2.376-0.676-4.326-2.034-5.853-1.423-1.57-3.31-2.352-5.661-2.352-2.272 0-4.076 0.752-5.424 2.258-1.346 1.505-2.019 3.403-2.019 5.69 0 2.399 0.692 4.36 2.083 5.884 1.387 1.53 3.258 2.293 5.612 2.293 2.268 0 4.094-0.754 5.472-2.259 1.316-1.466 1.971-3.35 1.971-5.661",
    clipPath: "url(#clipPath77)"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.3333 0 0 -1.3333 275.96 74.192)",
    d: "m0 0c-0.339 0.061-0.698 0.094-1.08 0.094-1.206 0-2.144-0.458-2.801-1.369-0.57-0.806-0.857-1.824-0.857-3.052v-8.111h-3.433l0.029 10.59c0 1.782-0.044 3.404-0.126 4.868h2.991l0.127-2.959h0.091c0.363 1.017 0.937 1.835 1.719 2.449 0.763 0.551 1.593 0.828 2.484 0.828 0.315 0 0.604-0.022 0.856-0.061z",
    clipPath: "url(#clipPath79)"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.3333 0 0 -1.3333 292.08 78.306)",
    d: "m0 0c0.024 1.015-0.198 1.896-0.665 2.639-0.595 0.954-1.51 1.432-2.738 1.432-1.121 0-2.034-0.468-2.734-1.401-0.573-0.743-0.913-1.631-1.014-2.67zm3.275-0.891c0-0.617-0.041-1.134-0.124-1.559h-10.302c0.039-1.527 0.539-2.695 1.493-3.501 0.866-0.721 1.993-1.077 3.372-1.077 1.521 0 2.913 0.242 4.166 0.73l0.539-2.387c-1.462-0.635-3.19-0.956-5.186-0.956-2.394 0-4.278 0.707-5.644 2.118-1.365 1.408-2.052 3.304-2.052 5.678 0 2.33 0.636 4.272 1.911 5.821 1.332 1.654 3.137 2.479 5.404 2.479 2.226 0 3.916-0.825 5.062-2.479 0.907-1.315 1.361-2.937 1.361-4.867",
    clipPath: "url(#clipPath81)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGetOnAppleStore);
export default __webpack_public_path__ + "static/media/get-on-apple-store.03856ebc40cd7d01a601facb34876a73.svg";
export { ForwardRef as ReactComponent };